import { createContext } from "react";
import { MapStore } from "@adactiveasia/adsign-map";
import { MainStore } from "./MainStore";

export const rootStoreContext = createContext({
  mapStore: new MapStore(),
  mainStore: new MainStore(),
});
